"use client";
import Link from "next/link";
import SwiperComponent from "@/components/ui/swiper-component";
import MediaComponent from "@core/helpers/client/components/image";
import Title from "../Title";
import DeviceOnly from "@/components/DeviceOnly";

function BrandCard({ item, storage_prefix_url }) {
    const bg = item?.["background-img"];
    const logo = item?.logo;
    const link = item?.link?.url || "#";

    return (
        <Link
            href={link}
            className="relative block rounded-md overflow-hidden h-[230px] lg:h-[340px] w-full group bg-jmt-neutral-200 [&_.shimmer-animation]:bg-jmt-neutral-200">
            {/* Background Image */}
            <div className="absolute inset-0 w-full h-full">
                <MediaComponent
                    src={bg?.url || ""}
                    alt={bg?.alt || "brand background"}
                    width={100}
                    height={100}
                    // کارت برند در اسلایدر: ۱۷۵ تا ۱۹۰px موبایل، تا ۲۴۴px دسکتاپ
                    sizes="(max-width:768px) 190px, 250px"
                    style={{ width: "100%", height: "100%" }}
                    storage_prefix_url={storage_prefix_url}
                    image_className="w-full h-full object-cover brightness-[0.85] transition-transform duration-500 group-hover:scale-105"
                />
            </div>

            {/* Logo Image Overlay — فقط وقتی لوگو در پنل ثبت شده باشد؛ وگرنه آیکون «بدون عکس» وسط کارت می‌افتد */}
            {logo?.url && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-[90px] lg:w-[104px] h-auto relative">
                        <MediaComponent
                            src={logo.url}
                            alt={logo?.alt || "brand logo"}
                            width={100}
                            height={100}
                            // لوگوی روی کارت: ۹۰px موبایل / ۱۰۴px دسکتاپ
                            sizes="104px"
                            style={{ width: "100%", height: "100%" }}
                            storage_prefix_url={storage_prefix_url}
                            image_className="w-full h-full object-contain"
                        />
                    </div>
                </div>
            )}
        </Link>
    );
}

export default function HomeSuggestBrand({ fields, storage_prefix_url }) {

    const brands = fields?.repeatable_fields || [];

    return (
        <>
            <DeviceOnly on="mobile">
                <div className="block lg:hidden w-full mx-auto">

                    <div className="pb-4 px-4 md:px-10">
                        <Title type={fields?.title?.type} className="text-base lg:text-xl font-bold text-jmt-main">
                            {fields?.title?.title || "برندهای پیشنهادی"}
                        </Title>
                    </div>

                    <SwiperComponent
                        slides={brands?.length > 0 ? brands.map((item, index) => (
                            <BrandCard
                                key={item.id || index}
                                item={item}
                                storage_prefix_url={storage_prefix_url}
                            />
                        )) : []
                        }
                        breakpoints={{
                            380: { slidesPerView: 2.1, spaceBetween: 8 },
                            500: { slidesPerView: 2.8, spaceBetween: 8 },
                            640: { slidesPerView: 3, spaceBetween: 8 },
                            767: { slidesPerView: 3.5, spaceBetween: 12 },
                            920: { slidesPerView: 4, spaceBetween: 12 },
                            1024: { slidesPerView: 4.5, spaceBetween: 16 },
                            1280: { slidesPerView: 5.5, spaceBetween: 16 },
                        }}
                        slidesPerView={1.5}
                        spaceBetween={8}
                        navigation={false}
                        swiper_className="px-4! md:px-10!"
                        grabCursor={true}
                    />

                </div>
            </DeviceOnly>

            <DeviceOnly on="desktop">
                <div className="hidden lg:block">
                    <div className="container">
                        <div className="pb-4">
                            <Title type={fields?.title?.type} className="text-base lg:text-xl font-bold text-jmt-main">
                                {fields?.title?.title || "برندهای پیشنهادی"}
                            </Title>
                        </div>

                        <SwiperComponent
                            slides={brands?.length > 0 ? brands.map((item, index) => (
                                <BrandCard
                                    key={item.id || index}
                                    item={item}
                                    storage_prefix_url={storage_prefix_url}
                                />
                            )) : []
                            }
                            breakpoints={{
                                380: { slidesPerView: 2.1, spaceBetween: 8 },
                                500: { slidesPerView: 2.8, spaceBetween: 8 },
                                640: { slidesPerView: 3, spaceBetween: 8 },
                                767: { slidesPerView: 3.5, spaceBetween: 12 },
                                920: { slidesPerView: 4, spaceBetween: 12 },
                                1024: { slidesPerView: 4.5, spaceBetween: 16 },
                                1280: { slidesPerView: 5.5, spaceBetween: 16 },
                            }}
                            slidesPerView={1.5}
                            spaceBetween={8}
                            navigation={true}
                            navPosition="side"
                            grabCursor={true}
                        />

                    </div>
                </div>
            </DeviceOnly>
        </>
    );
}
